// services/simulation/SimulationMimshakDataService.ts

import { SimulationMimshakData, SimulationSource } from "../interfaces/DTO/simulation";
import { MimshakDataService } from "./mimshakDataService";


export class SimulationMimshakDataService extends MimshakDataService {
  constructor(apiUrl: string = "/simulation_mimshak_data") {
    super(apiUrl);
  }

  async getBySimulationId(simulationId: number): Promise<SimulationMimshakData[]> {
    const response = await this.apiClient.get<SimulationMimshakData[]>(`${this.API_URL}/by_simulation`, {
      params: { simulation_id: simulationId },
    });
    return response.data;
  }
  async partialUpdateMany(updates: Partial<SimulationMimshakData>[]): Promise<void> {
    await this.apiClient.patch(`${this.API_URL}/bulk`, updates);
  }

  async replaceBySimulationId(simulationId: number, items: SimulationMimshakData[], source?: SimulationSource): Promise<void> {
    await this.apiClient.put(`${this.API_URL}/by_simulation`, items, {
      params: { simulation_id: simulationId, source },
    });
  }

}



export const simulationMimshakDataService = new SimulationMimshakDataService();
